import type { WithActiveBranchId } from '@app/api/shared';

export enum TimezonesEndpoints {
  GetTimezones = 'GetTimezones',
  GetCrmTimezones = 'GetCrmTimezones',
  ConvertTimezonesToLinux = 'ConvertTimezonesToLinux',
}

export interface ModelTimezone {
  Id: string | null;
  Name: string | null;
}

// GetTimezones/GetCrmTimezones отдают статический справочник и на фронте
// вызываются без филиала (регистрация — до авторизации; Sendouts/AddBranch — без
// ActiveBranchId). В swagger параметр необязательный, поэтому запрос — void.
export type GetTimezonesRequest = void;
export type GetCrmTimezonesRequest = void;
export type ConvertTimezonesToLinuxRequest = WithActiveBranchId;

export type GetTimezonesResponse = ModelTimezone[];
export type GetCrmTimezonesResponse = ModelTimezone[];
export type ConvertTimezonesToLinuxResponse = void;
